import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

export default function LeaveBarChart({ data }) {
  return (
    <div className="card shadow-sm border-0">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="mb-0 fw-semibold">Leaves</h6>

          <select className="form-select form-select-sm w-auto">
            <option>Office Management App</option>
          </select>
        </div>

        <ResponsiveContainer width="100%" height={210}>
          <BarChart data={data}>
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Legend />

            <Bar dataKey="annual" stackId="a" fill="#28a745" />
            <Bar dataKey="casual" stackId="a" fill="#ffc107" />
            <Bar dataKey="medical" stackId="a" fill="#0dcaf0" />
            <Bar dataKey="others" stackId="a" fill="#fd7e14" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}